import { Slot } from 'radix-ui'
import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/shared/lib/cn'
import s from './Button.module.css'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'secondary' | 'ghost' | 'accent'
  size?: 'sm' | 'md'
  /**
   * Отрисовать не `<button>`, а единственного ребёнка — с этими же стилями.
   *
   * Нужно для ссылок, которые выглядят кнопкой (открыть сервис «Компании», перейти в «Личный
   * кабинет»). Такую ссылку нельзя делать `<button onClick={() => location.assign(url)}>`:
   * пропадает Ctrl+клик, «открыть в новой вкладке», предпросмотр адреса в статусной строке и
   * сама роль ссылки в скринридере. Она обязана остаться `<a href>` — а кнопкой лишь выглядеть.
   */
  asChild?: boolean
  children?: ReactNode
}

export function Button({
  variant = 'secondary',
  size = 'md',
  asChild = false,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  const classes = cn(s.root, s[size], s[variant], className)

  if (asChild) {
    // `type` не прокидываем: у `<a>` он значил бы MIME-тип содержимого по ссылке.
    return <Slot.Root className={classes} {...rest} />
  }

  return <button type={type} className={classes} {...rest} />
}
